export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes'
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ceb8ca3d-857a-4987-a827-46f9823933cc';
export const MODAL_CLOSE_SEC = 2.5;